import { getClosedTickets } from "@/http/ticketsApi";
import { getClosedTicketsQueryKey } from "@/utils/queryKeys";
import { useQuery } from "@tanstack/react-query";

export const useGetClosedTicketsQuery = () => {
  return useQuery({
    queryKey: getClosedTicketsQueryKey(),
    queryFn: () => getClosedTickets(),
    select: (response) => response.data.data,
  });
};
